import { ReactElement } from 'react';

import { Flat } from '@dreryk/address-common-api';

import { commonTranslationKeys, FormContextValues, ValidationRules } from '@dreryk/react-common';
import { FlatInput } from '@dreryk/react-components';

const FLAT_FIELD_MAX_LENGTH = 10;

type FlatFormBeanPart = { flat: Flat | null };

const validationRules: ValidationRules<FlatFormBeanPart> = {
   maxLength: FLAT_FIELD_MAX_LENGTH,
};

type FlatFieldProps = Pick<FormContextValues<FlatFormBeanPart>, 'register'>;

export const FlatField = (props: FlatFieldProps): ReactElement => {
   return (
      <FlatInput
         testId={'flat'}
         label={commonTranslationKeys.addressData.apartmentNumberAbbreviation}
         controller={props.register('flat', validationRules)}
         defaultValue={null}
      />
   );
};
